module.exports = __webpack_public_path__ + "static/img/chery_5@2x.9b1d408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_5@2x.png
// module id = b+7w
// module chunks = 0